import { HandWaveOutlineIcon } from './HandWaveOutlineIcon';

/**
 * author: Google
 * id 0E2992F4-2F2E-4A96-8402-FBA2B9C8675C
 * name hand-wave-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/hand-wave-outline.svg
 * tags
 */
export const GreetingOutlineIcon = HandWaveOutlineIcon;
export default GreetingOutlineIcon